<template>
  <div>
    <sweet-modal
      overlay-theme="dark"
      hide-close-button
      ref="modal"
      enable-mobile-fullscreen
      class="no-padding-content"
      :width="modalWidth"
      @close="modalClosed"
    >
      <div class="bg-modal-gradient flex justify-between items-center p-6">
        <div class="text-white text-3xl">
          <i class="fa fa-calendar mr-4"></i> View event
        </div>
        <button
          type="button"
          class="text-white text-2xl hover:text-grey"
          @click="$refs.modal.close()"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div class="flex flex-col md:flex-row">
        <div
          class="iframe-container flex-1 mr-2"
          v-if="
            currentEvent.files != undefined &&
            currentEvent.files.length > 0 &&
            !editing
          "
        >
          <div
            class="justify-center items-center h-screen flex flex-col"
            v-if="previewLoading"
          >
            <i class="fa fa-circle-notch fa-spin"></i>
            loading
          </div>
          <iframe
            :src="previewUrl"
            frameborder="0"
            style="overflow: hidden; height: 100%; width: 100%"
            height="100%"
            width="100%"
            class="iframe"
          ></iframe>
        </div>
        <div class="flex-1 p-6">
          <div
            v-if="
              !editing && attached_user && attached_user.pivot.is_attend == null
            "
            class="bg-grey-light px-6 py-4 rounded mb-4"
          >
            <p class="my-2 font-medium">Do you want to attend this event?</p>
            <div class="flex justify-center mb-2">
              <button
                class="
                  bg-brand
                  rounded-lg
                  text-white
                  hover:bg-brand-dark
                  font-medium
                  mr-2
                  px-3
                  py-2
                "
                @click="confirmEvent(true)"
              >
                Accept
              </button>
              <button
                class="
                  bg-grey-darker
                  rounded-lg
                  text-white
                  hover:bg-grey-dark
                  font-medium
                  ml-2
                  px-3
                  py-2
                "
                @click="confirmEvent(false)"
              >
                Decline
              </button>
            </div>
          </div>
          <div v-if="attached_user && attached_user.pivot.is_attend != null">
            <p
              class="font-medium text-sm text-center md:text-left mb-2 md:mb-0"
              :class="[
                attached_user.pivot.is_attend == 1
                  ? 'text-green'
                  : 'text-orange',
              ]"
            >
              You have
              {{ attached_user.pivot.is_attend ? "accepted" : "declined" }} this
              event.
            </p>
          </div>
          <div>
            <!-- Event view -->
            <div class="w-full text-left" v-if="!editing">
              <div class="flex flex-col-reverse md:flex-row justify-between">
                <p class="text-xl md:text-2xl font-bold">
                  {{ currentEvent.title }}
                </p>
                <span
                  class="
                    rounded-full
                    text-xs text-white
                    bg-brand
                    rounded
                    py-2
                    px-3
                    self-center
                    mb-2
                    md:mb-0
                  "
                  style="width: fit-content"
                >
                  {{ recurringText(currentEvent.recurring) }}
                </span>
              </div>
              <div class="flex mt-4 flex-col md:flex-row">
                <p class="text-grey-darker w-48">
                  <i class="fas fa-users mr-1"></i> Attending
                </p>
                <div
                  class="flex flex-wrap mt-2 md:mt-0"
                  v-if="attendingUsers.length > 0"
                >
                  <span
                    v-for="user of attendingUsers"
                    :key="user.id"
                    class="border rounded-lg px-2 py-1 mr-2 text-xs mb-2"
                  >
                    <i class="fas fa-check-circle text-brand mr-1"></i>
                    {{ getUserFullName(user) }}
                  </span>
                </div>
                <div v-else class="mt-2 md:mt-0">-</div>
              </div>
              <div class="flex flex-col md:flex-row mt-4">
                <p class="text-grey-darker w-48">
                  <i class="fas fa-comment mr-2"></i>Description
                </p>
                <p class="mt-2 md:mt-0">
                  {{ currentEvent.description }}
                </p>
              </div>
              <div class="flex flex-col md:flex-row mt-4">
                <p class="text-grey-darker w-48">
                  <i class="fas fa-clock mr-2"></i>Date
                </p>
                <p class="mt-2 md:mt-0">
                  <span>
                    {{
                      customFormatDate(
                        currentEvent.start_at,
                        "YYYY-MM-DD HH:mm:ss",
                        "MMM DD, YYYY hh:mm A"
                      )
                    }}
                  </span>
                  <span v-if="currentEvent.end_at">
                    -
                    {{
                      customFormatDate(
                        currentEvent.end_at,
                        "YYYY-MM-DD HH:mm:ss",
                        "MMM DD, YYYY hh:mm A"
                      )
                    }}
                  </span>
                </p>
              </div>
              <div
                class="flex flex-col md:flex-row mt-4"
                v-if="currentEvent.recurring_end_date"
              >
                <p class="text-grey-darker w-48">
                  <i class="fas fa-calendar mr-2"></i>Recurring Until
                </p>
                <p class="mt-2 md:mt-0">
                  {{
                    customFormatDate(
                      currentEvent.recurring_end_date,
                      "YYYY-MM-DD",
                      "MMM DD, YYYY"
                    )
                  }}
                </p>
              </div>
            </div>
            <form
              @submit.prevent="updateEvent"
              data-vv-scope="update-event"
              enctype="multipart/form-data"
            >
              <div class="w-full text-left my-4" v-if="editing">
                <div class="flex justify-between">
                  <label class="font-medium"
                    >Title
                    <span class="text-red" v-show="editing">*</span></label
                  >
                  <label class="text-red text-sm font-medium" v-show="editing"
                    >* Required info</label
                  >
                </div>
                <input
                  type="text"
                  class="w-full h-10 border rounded px-3 mt-1"
                  v-model="currentEvent.title"
                  v-validate="'required'"
                  name="title"
                  tabindex="1"
                  :readonly="!editing"
                  :class="{
                    'border-red': errors.has('update-event.title'),
                    border: editing,
                  }"
                />
                <div
                  v-show="errors.has('update-event.title')"
                  class="text-red text-sm mt-1"
                >
                  {{ errors.first("update-event.title") }}
                </div>
              </div>

              <div class="w-full text-left my-4" v-if="editing">
                <label class="font-medium"
                  >Event Details
                  <span class="text-red" v-show="editing">*</span></label
                >
                <textarea
                  type="text"
                  class="w-full border rounded py-2 px-3 mt-1"
                  v-model="currentEvent.description"
                  v-validate="'required'"
                  name="description"
                  tabindex="1"
                  :readonly="!editing"
                  :class="{
                    'border-red': errors.has('update-event.description'),
                    border: editing,
                  }"
                ></textarea>
                <div
                  v-show="errors.has('update-event.description')"
                  class="text-red text-sm mt-1"
                >
                  {{ errors.first("update-event.description") }}
                </div>
              </div>

              <!-- Edit post event to -->
              <div
                class="w-full text-left flex flex-col md:flex-row mb-4 mt-2"
                v-if="editing"
              >
                <div class="flex-1 mr-0 md:mr-2">
                  <label class="font-medium"
                    >Start <span class="text-red">*</span></label
                  >
                  <div class="flex mt-2">
                    <flat-pickr
                      :config="flatPickrConfig.start"
                      :events="[
                        'on-change',
                        'on-close',
                        'on-destroy',
                        'on-key-down',
                        'on-month-change',
                        'on-open',
                        'on-parse-config',
                        'on-ready',
                        'on-value-update',
                      ]"
                      class="appearance-none w-full h-10 border rounded px-3 text-black rounded-tr-none rounded-br-none"
                      placeholder="Select Date"
                      v-model="currentEvent.start_date"
                      name="start_date"
                      v-validate="'required'"
                      :class="{
                        'border-red': errors.has('update-event.start_date'),
                      }"
                    ></flat-pickr>
                    <button
                      type="button"
                      class="text-white h-10 px-4 rounded-tr rounded-br"
                      :class="[
                        errors.has('update-event.start_date')
                          ? 'bg-red'
                          : 'bg-brand',
                      ]"
                      data-toggle
                    >
                      <i class="fa fa-calendar-alt"></i>
                    </button>
                  </div>
                  <div
                    v-show="errors.has('update-event.start_date')"
                    class="text-red text-sm mt-1"
                  >
                    {{ errors.first("update-event.start_date") }}
                  </div>
                </div>
                <div class="flex-1 mt-4 md:mt-0 ml-0 md:ml-2">
                  <label class="font-medium">Finish</label>
                  <div class="flex mt-2">
                    <flat-pickr
                      class="appearance-none w-full h-10 border rounded px-3 text-black rounded-tr-none rounded-br-none"
                      placeholder="Select Date"
                      :config="flatPickrConfig.end"
                      :events="[
                        'on-change',
                        'on-close',
                        'on-destroy',
                        'on-key-down',
                        'on-month-change',
                        'on-open',
                        'on-parse-config',
                        'on-ready',
                        'on-value-update',
                      ]"
                      v-model="currentEvent.end_date"
                    ></flat-pickr>
                    <button
                      type="button"
                      class="text-white h-10 px-4 rounded-tr rounded-br
                        bg-brand"
                      data-toggle
                    >
                      <i class="fa fa-calendar-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="w-full text-left flex flex-col md:flex-row mb-4 mt-2"
                v-if="editing"
              >
                <div class="flex-1 mr-0 md:mr-2 mt-4 md:mt-0">
                  <label class="font-medium">Recurring</label>
                  <div class="flex mt-2 recurring">
                    <multiselect
                      v-model="recurring"
                      class="rounded"
                      :class="{
                        'border-red': errors.has('add-event.selected_users'),
                      }"
                      track-by="id"
                      :custom-label="recurringCustomLabel"
                      :options="recurringOptions"
                      :showLabels="false"
                      name="recurring"
                      v-validate="'required'"
                      open-direction="below"
                    >
                    </multiselect>
                  </div>
                </div>
                <div class="flex-1 ml-0 md:ml-2 mt-4 md:mt-0">
                  <label class="font-medium">End Date</label>
                  <div class="flex mt-2">
                    <flat-pickr
                      class="appearance-none w-full h-10 border rounded px-3 text-black rounded-tr-none rounded-br-none"
                      placeholder="Select Date"
                      :config="flatPickrConfigRecurring"
                      :events="[
                        'on-change',
                        'on-close',
                        'on-destroy',
                        'on-key-down',
                        'on-month-change',
                        'on-open',
                        'on-parse-config',
                        'on-ready',
                        'on-value-update',
                      ]"
                      v-model="recurring_end_date"
                      :disabled="!isRecurring"
                      tabindex="6"
                    ></flat-pickr>
                    <button
                      type="button"
                      class="text-white h-10 px-4 rounded-tr rounded-br
                        bg-brand"
                      data-toggle
                    >
                      <i class="fa fa-calendar-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="w-full text-left my-4" v-if="editing">
                <label class="font-medium"
                  >Notify <span class="text-red">*</span></label
                >
                <div class="flex flex-col md:flex-row my-2 text-sm">
                  <label class="flex items-center mr-4">
                    <input
                      type="radio"
                      name="type"
                      v-model="send_to"
                      value="all_member"
                      class="mr-2"
                      @click="show_users = false"
                      checked
                    />
                    All Vault members
                  </label>
                  <label class="flex items-center mr-4">
                    <input
                      type="radio"
                      name="type"
                      v-model="send_to"
                      value="pick_users"
                      class="mr-2"
                      @click="show_users = true"
                      checked
                    />
                    Let me choose who receives it
                  </label>
                  <label class="flex items-center">
                    <input
                      type="radio"
                      name="type"
                      v-model="send_to"
                      value="only_me"
                      class="mr-2"
                      @click="show_users = false"
                      checked
                    />
                    Don't notify anyone
                  </label>
                </div>
                <div class="my-2" v-if="show_users">
                  <multiselect
                    v-model="selected_users"
                    class="rounded"
                    :class="{
                      'border-red': errors.has('update-event.selected_users'),
                    }"
                    track-by="id"
                    :custom-label="multiSelectCustomLabel"
                    placeholder="Search a User"
                    :options="vaultUsers"
                    :showLabels="false"
                    :hide-selected="true"
                    name="selected_users"
                    v-validate="'required'"
                    open-direction="below"
                    :multiple="true"
                  >
                    <template slot="tag" slot-scope="props">
                      <span
                        class="
                          bg-brand-lighter
                          text-grey-dark
                          rounded-lg
                          p-1
                          m-1
                        "
                      >
                        <span class="font-semibold px-2"
                          >{{ props.option.first_name }}
                          {{ props.option.last_name }}</span
                        >
                        <span
                          class="text-brand border-l border-brand-dark px-2"
                          @click="props.remove(props.option)"
                        >
                          <i class="fa fa-times"></i>
                        </span>
                      </span>
                    </template>
                  </multiselect>
                  <div
                    v-show="errors.has('update-event.selected_users')"
                    class="text-red text-sm mt-1"
                  >
                    {{ errors.first("update-event.selected_users") }}
                  </div>
                </div>
              </div>

              <div
                class="flex items-start my-4 flex-col"
                v-if="
                  !editing &&
                  currentEvent.files &&
                  currentEvent.files.length > 0
                "
              >
                <p class="font-medium">Attached files</p>
                <div class="text-left text-sm mt-2">
                  <p
                    v-for="file in currentEvent.files"
                    :key="file.id"
                    class="flex"
                  >
                    <button
                      type="button"
                      class="mr-2 text-red"
                      v-if="user.id == currentEvent.user_id"
                      @click="removeFileFromEvent(file)"
                    >
                      <i class="fa fa-times-circle"></i>
                    </button>
                    <button @click="downloadFile(file)" class="mr-2 text-blue" type="button">
                      <i class="fa fa-download"></i>
                    </button>
                    <a
                      @click.prevent="previewFile(file)"
                      class="
                        text-black
                        hover:text-brand
                        cursor-pointer
                        underline
                      "
                    >
                      {{ file.filename }}
                    </a>
                  </p>
                </div>
              </div>

              <div class="my-8">
                <file-upload
                  ref="editFileUpload"
                  v-show="editing && !vault.storage_exceeded"
                ></file-upload>
              </div>

              <div v-if="editing">
                <div
                  v-if="vault.storage_exceeded"
                  class="
                    mt-4
                    bg-red-lightest
                    border border-dashed
                    w-full
                    p-1
                    border-red
                    text-sm
                  "
                >
                  Vault Storage Exceeded, uploading is not allowed
                </div>
              </div>

              <div
                class="mt-6 flex justify-between items-center"
                v-if="can_be_edited"
              >
                <div v-if="editing == true">
                  <button
                    class="bg-brand border border-brand text-white text-sm font-medium py-2 px-4 rounded hover:bg-brand-dark hover:border-brand-dark"
                    type="submit"
                  >
                    <i class="fa fa-save mr-2"></i> Update
                  </button>
                  <button
                    type="button"
                    class="border border-grey bg-white text-grey-darker text-sm font-medium py-2 px-4 rounded hover:bg-grey-lightest ml-2"
                    @click.prevent="editing = false"
                  >
                    Cancel
                  </button>
                </div>
                <button
                  class="bg-brand border border-brand text-white text-sm font-medium py-2 px-4 rounded hover:bg-brand-dark hover:border-brand-dark"
                  v-if="editing == false"
                  type="button"
                  @click.prevent="editing = true"
                >
                  <i class="fa fa-edit mr-2"></i> Edit
                </button>

                <button
                  type="button"
                  class="border border-red bg-white text-red text-sm font-medium py-2 px-4 rounded hover:bg-red hover:text-white"
                  @click.prevent="$refs.delete_event.open()"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </sweet-modal>

    <confirm-dialog
      ref="delete_event"
      title="Delete this event?"
      body="This cannot be undone."
      action-label="Delete"
      @confirm="deleteEvent"
    ></confirm-dialog>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import ConfirmDialog from "../../../ConfirmDialog.vue";
import FileUpload from "../FileUpload.vue";

export default {
  name: "ViewEvent",
  props: ["selected_event", "user", "role", "vault", "vaultUsers"],
  components: {
    ConfirmDialog,
    flatPickr,
    FileUpload,
  },
  data() {
    return {
      previewLoading: false,
      previewUrl: "",
      editing: false,
      attached_user: null,
      send_to: "only_me",
      show_users: false,
      selected_users: [],
      recurring_end_date: "",
      recurring: {
        id: 0,
        label: "Doesn't Repeat",
      },
      recurringOptions: [
        {
          id: 0,
          label: "Doesn't Repeat",
        },
        {
          id: 1,
          label: "Weekly",
        },
        {
          id: 2,
          label: "Monthly",
        },
        {
          id: 3,
          label: "Annually",
        },
      ],
      can_be_edited: false,

      flatPickrConfig: {
        start: {
          wrap: true,
          allowInput: false,
          // minDate: "today",
          dateFormat: "d/m/Y h:i K",
          enableTime: true,
          monthSelectorType: "static",
        },
        end: {
          wrap: true,
          allowInput: false,
          // minDate: "today",
          defaultDate: null,
          dateFormat: "d/m/Y h:i K",
          enableTime: true,
          monthSelectorType: "static",
        },
      },
      flatPickrConfigRecurring: {
        wrap: true,
        allowInput: false,
        defaultDate: null,
        dateFormat: "d/m/Y",
        enableTime: false,
        monthSelectorType: "static",
      },
    };
  },
  computed: {
    isRecurring() {
      if (this.recurring) {
        return this.recurring.id != 0;
      }
      return false;
    },
    attendingUsers() {
      if (this.currentEvent && this.currentEvent.users) {
        return this.currentEvent.users.filter((user) => user.pivot.is_attend);
      }
      return [];
    },
    currentEvent: {
      get: function () {
        if (this.selected_event.user_id == this.user.id || this.canAccess()) {
          this.can_be_edited = true;
        }

        this.recurring = this.recurringOptions.find(
          (option) => option.id == this.selected_event.recurring
        );

        // format recurring end date if it's not null
        if (this.selected_event.recurring_end_date) {
          this.recurring_end_date = moment(
            this.selected_event.recurring_end_date
          ).format("DD/MM/YYYY");
        }

        return this.selected_event;
      },
      set: function (value) {
        this.$emit("currentEvent", value);
      },
    },
    modalWidth() {
      if (this.$mq == "mobile") {
        return "100%";
      } else {
        if (
          this.currentEvent.files &&
          this.currentEvent.files.length > 0 &&
          !this.editing
        ) {
          return "80%";
        }
      }
      return "50%";
    },
  },
  methods: {
    recurringText(recurring) {
      const recurringText = ["Doesn't Repeat", "Weekly", "Monthly", "Annually"];
      return recurringText[recurring];
    },
    recurringCustomLabel(option) {
      return option.label;
    },
    getUserFullName(user) {
      const { first_name, last_name } = user;

      if (!last_name) {
        return first_name;
      }

      return `${first_name} ${last_name}`;
    },

    downloadFile(file) {
      axios
        .get(`api/vaults/${file.vault_id}/files/${file.id}/download-path`, {
          params: {
            is_download: 1,
          },
        }).then(({ data }) => {
          window.open(data.url, '_blank');
        })
    },
    
    previewFile(file) {
      this.previewLoading = true;
      axios
        .get(`api/vaults/${file.vault_id}/files/${file.id}/download-path`, {
          params: {
            is_download: 0,
          },
        })
        .then(({ data }) => {
          this.previewLoading = false;
          if (/\.pdf$/i.test(file.filename)) {
            this.previewUrl =
              `/pdf_viewer_3/viewer.html?file=` + encodeURIComponent(data.url);
          } else {
            let office_file_exts = [
              "doc",
              "docx",
              "dotx",
              "odt",
              "ppt",
              "pptx",
              "odp",
              "xls",
              "xlsx",
              "ods",
            ];
            let file_ext_matches = file.filename.match(/[^.]+$/);
            if (file_ext_matches.length > 0) {
              let file_ext = file_ext_matches[0];
              if (office_file_exts.indexOf(file_ext) >= 0) {
                let baseURL = "https://docs.google.com/gview?url=";
                if(file_ext == "doc") {
                  baseURL = "https://view.officeapps.live.com/op/embed.aspx?src=";
                }
                // old URL: https://docs.google.com/viewer?url=
                this.previewUrl =
                  baseURL +
                  encodeURIComponent(data.url) +
                  "&embedded=true&headers=true";
              } else {
                this.previewUrl = data.url;
              }
            } else {
              this.previewUrl = data.url;
            }
          }
        });
    },
    canAccess() {
      if (_.includes(["userA", "userB", "userC", "userD"], this.role)) {
        return true;
      }
      return false;
    },
    fillPostEventTo() {
      if (
        this.currentEvent.users.length == 1 &&
        this.currentEvent.users[0].id == this.user.id
      ) {
        this.selected_users = [];
        this.show_users = false;
        this.send_to = "only_me";
        return;
      }

      if (this.currentEvent.users.length == this.vaultUsers.length) {
        this.selected_users = [];
        this.show_users = false;
        this.send_to = "all_member";
        return;
      }

      this.show_users = true;
      this.selected_users = this.currentEvent.users;
      this.send_to = "pick_users";
    },
    setAttachedUser() {
      if (this.selected_event && this.selected_event.users) {
        const attached = this.selected_event.users.find((user) => {
          if (user.id == this.user.id) {
            return user;
          }
        });
        if (attached) {
          this.attached_user = attached;
        } else {
          this.attached_user = null;
        }
      }
    },
    removeFileFromEvent(file) {
      axios
        .delete(
          `api/vaults/${this.$route.params.vault_id}/events/${this.currentEvent.id}/files/${file.id}`
        )
        .then((response) => {
          if (response && response.data) {
            const data = response.data;
            if (data.success) {
              this.currentEvent.files = this.currentEvent.files.filter(
                (f) => f.id != file.id
              );

              if (
                this.currentEvent.files &&
                this.currentEvent.files.length > 0
              ) {
                this.previewFile(this.currentEvent.files[0]);
              }

              this.$noty.success(data.message);
              this.$emit("getEvents");
            } else {
              this.$noty.error(data.message);
            }
          }
        });
    },
    customFormatDate(date, currentDateFormat, format) {
      if (date) {
        return moment(date, currentDateFormat).format(format);
      }
      return "-";
    },
    modalClosed() {
      this.previewUrl = "";
      this.attached_user = null;
      this.send_to = "only_me";
      this.editing = false;
      this.show_users = false;
      this.can_be_edited = false;
      this.recurring_end_date = "";
      this.selected_users = [];
      this.flatPickrConfigRecurring.defaultDate = null;
      this.flatPickrConfig.end.defaultDate = null;
      this.recurring = {
        id: 0,
        label: "Doesn't Repeat",
      };
      this.errors.clear("update-event");
      this.$refs.editFileUpload.cleanup();
    },
    updateEvent() {
      this.$validator.validateAll("update-event").then((result) => {
        if (result) {
          this.$emit("processing", true);

          let end_at = "";
          const start_at = moment(
            this.currentEvent.start_date,
            "DD/MM/YYYY HH:mm A"
          ).format("YYYY-MM-DD HH:mm:ss");
          if (this.currentEvent.end_date) {
            end_at = moment(
              this.currentEvent.end_date,
              "DD/MM/YYYY HH:mm A"
            ).format("YYYY-MM-DD HH:mm:ss");
          }

          let participant_user_ids = [];

          if (this.send_to == "all_member") {
            participant_user_ids = _.map(this.vaultUsers, "id");
          }

          if (this.send_to == "pick_users") {
            participant_user_ids = _.map(this.selected_users, "id");
          }

          if (this.send_to == "only_me") {
            participant_user_ids = [this.user.id];
          }

          let recurring_end_date = "";
          if (this.recurring_end_date) {
            recurring_end_date = moment(
              this.recurring_end_date,
              "DD/MM/YYYY"
            ).format("YYYY-MM-DD");
          }

          const formData = new FormData();
          formData.append("_method", "PATCH");
          formData.append("title", this.currentEvent.title);
          formData.append("description", this.currentEvent.description);
          formData.append("start_at", start_at);
          formData.append("end_at", end_at);
          formData.append("recurring", this.recurring.id);
          formData.append("recurring_end_date", recurring_end_date);
          participant_user_ids.forEach((id, index) => {
            formData.append(`participant_user_ids[${index}]`, id);
          });

          const files = this.$refs.editFileUpload.getFiles();
          const vaultFiles = this.$refs.editFileUpload.getVaultFiles();
          files.forEach((file, index) => {
            formData.append(`files[${index}]`, file);
          });
          vaultFiles.forEach((file, index) => {
            formData.append(`vault_files[${index}]`, file.id);
          });

          axios
            .post(
              `api/vaults/${this.$route.params.vault_id}/events/${this.currentEvent.id}`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then(({ data }) => {
              this.$emit("eventUpdated");
            })
            .finally(() => {
              this.editing = false;
              this.$emit("processing", false);
              this.$refs.modal.close();
            });
        }
      });
    },
    confirmEvent(accepted) {
      axios
        .post(
          `/api/vaults/${this.$route.params.vault_id}/events/${this.currentEvent.id}/confirm`,
          {
            is_attend: accepted ? 1 : 0,
          }
        )
        .then(({ data }) => {
          if (data.success) {
            this.$noty.success(data.message);
            this.attached_user.pivot.is_attend = accepted ? 1 : 0;
          } else {
            this.$noty.error(data.message);
          }
          this.$emit("getEvents");
        });
    },
    deleteEvent() {
      axios
        .delete(
          `api/vaults/${this.$route.params.vault_id}/events/${this.currentEvent.id}`
        )
        .then(({ data }) => {
          if (data.success) {
            this.$emit("eventDeleted");
          }
        })
        .finally(() => {
          this.$refs.delete_event.close();
          this.$refs.modal.close();
        });
    },
    multiSelectCustomLabel(user) {
      if (!user.last_name) {
        return user.first_name;
      }
      return user.first_name + " " + user.last_name;
    },
  },
  watch: {
    recurring(value) {
      if (value && value.id == 0) {
        this.recurring_end_date = "";
      }
    },
    currentEvent(value) {
      if (value.files != undefined && value.files.length > 0) {
        this.previewFile(value.files[0]);
      }
    },
    send_to(value) {
      if (value == "pick_users") {
        this.selected_users = [];
        if (this.currentEvent && this.currentEvent.users) {
          this.selected_users = [...this.currentEvent.users];

          const foundIndex = this.currentEvent.users.findIndex(
            (user) => user.id == this.user.id
          );

          if (foundIndex < 0) {
            this.selected_users.push(this.user);
          }
        } else {
          this.selected_users.push(this.user);
        }
      }
    },
  },
};
</script>

<style scoped>
button:focus {
  outline: none;
}


.iframe-container {
  position: relative;
  padding-bottom: 56.25%; /* proportion value to aspect ratio 16:9 (9 / 16 = 0.5625 or 56.25%) */
  height: 0;
  overflow: hidden;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .iframe-container {
    height: 75vh;
  }
}

</style>
